import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

const STATUS_MAP = {
  completed: { type: 'success', text: 'Verified' },
  verified: { type: 'success', text: 'Verified' },
  expired: { type: 'failed', text: 'Failed verification' },
  pending: { type: 'warning', text: 'Pending bank verification' },
  pending_manual: { type: 'warning', text: 'Pending user verification' },
};

const styles = ({ palette }) => ({
  all: {
    height: 24,
    borderRadius: 8,
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0.32px',
  },
  success: {
    backgroundColor: palette.cncUI.alert.green['+2'],
    color: palette.cncUI.alert.green['-1'],
  },
  warning: {
    backgroundColor: palette.cncUI.alert.yellow['+2'],
    color: palette.cncUI.alert.yellow['-1'],
  },
  failed: {
    backgroundColor: palette.cncUI.alert.red['+2'],
    color: palette.cncUI.alert.red['-1'],
  },
});

const BankStatus = props => {
  const { bank, classes } = props;
  const status = STATUS_MAP[bank.status] || { type: '', text: bank.status };
  const type = clsx(classes.all, classes[status.type]);
  return <Chip label={status.text} className={type} />;
};

export default withStyles(styles)(BankStatus);
